import { useIntl } from 'react-intl'
import { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import { getSVGImageUrl } from 'lib/image/imageUtils'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineUsersAltIcon from 'LuxKit/Icons/line/LineUsersAltIcon'
import GoogleLongLogo from 'components/Common/TrustIndicators/GoogleLongLogo'
import Group from 'components/utils/Group'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'

function AccountAccessTrustIndicatorsMapper() {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)

  return (
    <Group direction="horizontal" gap={24} verticalAlign="center" horizontalAlign="center" wrap="wrap">
      {currentRegionCode === 'GB' && <Group direction="horizontal" gap={4} verticalAlign="center">
        <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width={20} height={20} alt="" />
        <BodyTextBlock variant="medium" weight="bold" wrap="no-wrap">
          {intl.formatMessage({
            id: 'VxW64n9lfPWXpeyYxquy',
            defaultMessage: 'ATOL protected',
            description: 'ATOL protection label in UK trust indicator in the insurance flow',
          })}
        </BodyTextBlock>
      </Group>}
      <Group direction="horizontal" gap={8} verticalAlign="center">
        <GoogleLongLogo width="54" height="18" />
        <BodyTextBlock variant="medium" weight="bold" wrap="no-wrap">
          {intl.formatMessage({
            id: 'AFF9frfzVWiHNAba93vz',
            defaultMessage: '4.7/5',
            description: 'Google review rating score displayed on login modal',
          })}
        </BodyTextBlock>
        <CSSBreakpoint min="desktop">
          <BodyTextBlock variant="small" colour="light-foreground-alt" wrap="no-wrap">
            {intl.formatMessage({
              id: 'f2iP-sfiwGgXwdk6j1qW',
              defaultMessage: '(4.5K reviews)',
              description: 'Google review count displayed on login modal in the reviews section',
            })}
          </BodyTextBlock>
        </CSSBreakpoint>
      </Group>
      <BodyTextBlock
        variant="medium"
        wrap="no-wrap"
        startIcon={<LineUsersAltIcon size="S" colour="primary" aria-hidden="true" />}
      >
        {intl.formatMessage({
          id: 'dNtkovUEOoWPVfB1ibtU',
          defaultMessage: '15 million members',
          description: 'Member count displayed beneath membership benefits in login and offer sign-up panels',
        })}
      </BodyTextBlock>
    </Group>
  )
}

export default AccountAccessTrustIndicatorsMapper
